const numberToThousandComma = (num) => {
	return typeof num === "number"
		? new Intl.NumberFormat("en-US").format(num)
		: num;
};

export default numberToThousandComma;
